const elementRemainsOutsideViewport = ({
  top,
  bottom,
  prevTop,
  prevBottom,
  windowHeight
}) =>
  (top > windowHeight || bottom < 0) &&
  (prevTop > windowHeight || prevBottom < 0);

const elementMoved = ({ leftDiff, topDiff }) => !!(leftDiff || topDiff);

const setInitialPosition = ({ element, leftDiff, topDiff }) => {
  const transforms = [];
  if (leftDiff) {
    transforms.push(`translateX(${leftDiff}px)`);
  }
  if (topDiff) {
    transforms.push(`translateY(${topDiff}px)`);
  }
  element.style.transform = transforms.join(" ");
};

const processSingleElement = ({
  elementPosition: { top, bottom, left, key, element },
  recordedPositions,
  windowHeight,
  toAnimate
}) => {
  const prevPosition = recordedPositions.find(
    ({ key: candiateKey }) => candiateKey === key
  );

  if (!prevPosition) return false;

  const { top: prevTop, left: prevLeft, bottom: prevBottom } = prevPosition;

  const leftDiff = prevLeft - left;
  const topDiff = prevTop - top;

  if (!elementMoved({ leftDiff, topDiff })) {
    return;
  }

  if (
    elementRemainsOutsideViewport({
      top,
      bottom,
      prevTop,
      prevBottom,
      windowHeight
    })
  ) {
    return;
  }

  const moveDiagonally = leftDiff !== 0 && topDiff !== 0;

  toAnimate.push({ element, moveDiagonally });

  setInitialPosition({ element, leftDiff, topDiff });
};

export default processSingleElement;
